<div class="ngx-pe-overlay-container">
  <div class="ngx-pe-dialog-container" [style.max-width]="modalMaxWidth">
    <!-- Header -->
    <div class="ngx-pe-dialog-header" *ngIf="!hideModalHeader">
      {{ modalTitle }}
    </div>

    <!-- Body -->
    <div class="ngx-pe-dialog-body">
      <div class="ngx-pe-cropper-wrapper">
        <!-- Loader -->
        <div
          class="ngx-pe-loading"
          *ngIf="!imageLoaded"
          [class.ngx-pe-processing]="isProcessing"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            style="margin: auto; display: block; shape-rendering: auto"
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
          >
            <circle
              cx="50"
              cy="50"
              fill="none"
              stroke="#f3f3f3"
              stroke-width="10"
              r="35"
              stroke-dasharray="164.93361431346415 56.97787143782138"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                repeatCount="indefinite"
                dur="1s"
                values="0 50 50;360 50 50"
                keyTimes="0;1"
              ></animateTransform>
            </circle>
          </svg>
        </div>

        <!-- 🌟 CropperJS v2 -->
        <cropper-canvas background #canvas>
          <cropper-image
            id="image"
            #image
            [src]="imgUrl"
            [attr.src]="imgUrl"
            alt="Picture"
            rotatable
            scalable
            skewable
            translatable
          ></cropper-image>
          <cropper-shade hidden></cropper-shade>
          <cropper-handle action="select" plain></cropper-handle>
          <cropper-selection #selection movable resizable>
            <cropper-grid role="grid" covered></cropper-grid>
            <cropper-crosshair centered></cropper-crosshair>
            <cropper-handle
              class="border border-primary-subtle"
              action="move"
              theme-color="rgba(255, 255, 255, 0)"
            ></cropper-handle>
            <cropper-handle action="n-resize"></cropper-handle>
            <cropper-handle action="e-resize"></cropper-handle>
            <cropper-handle action="s-resize"></cropper-handle>
            <cropper-handle action="w-resize"></cropper-handle>
            <cropper-handle action="ne-resize"></cropper-handle>
            <cropper-handle action="nw-resize"></cropper-handle>
            <cropper-handle action="se-resize"></cropper-handle>
            <cropper-handle action="sw-resize"></cropper-handle>
          </cropper-selection>
        </cropper-canvas>

        <!-- Toolbar -->
        <div class="ngx-pe-tool-bar">
          <button (click)="zoomIn()" title="Zoom In">
            <img src="assets/perval-icons/zoom-in.svg" alt="zoomer" />
          </button>
          <button (click)="zoomOut()" title="Zoom Out">
            <img src="assets/perval-icons/zoom-out.svg" alt="dézoomer" />
          </button>
          <button (click)="rotateLeft()" title="Rotate Left">
            <img
              src="assets/perval-icons/arrow-clockwise.svg"
              alt="rotation droite"
            />
          </button>
          <button (click)="rotateRight()" title="Rotate Right">
            <img
              src="assets/perval-icons/arrow-counterclockwise.svg"
              alt="rotation gauche"
            />
          </button>
          <button (click)="flipH()" title="Flip Horizontal">
            <img
              src="assets/perval-icons/symmetry-horizontal.svg"
              alt="rotation horizontal"
            />
          </button>
          <button (click)="flipV()" title="Flip Vertical">
            <img
              src="assets/perval-icons/symmetry-vertical.svg"
              alt="rotation vertical"
            />
          </button>
          <button (click)="reset()" title="Reset">
            <img
              src="assets/perval-icons/arrow-repeat.svg"
              alt="réinitialiser"
            />
          </button>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="ngx-pe-dialog-footer">
      <button class="ngx-pe-btn ngx-pe-btn-outline-light" (click)="close()">
        {{ closeBtnText }}
      </button>
      <button class="ngx-pe-btn ngx-pe-btn-primary" (click)="export()">
        {{ applyBtnText }}
      </button>
    </div>
  </div>
</div>
